import { Component, Inject, OnInit } from '@angular/core';
import {
  BulkPriceStepComponent,
  PurchasePrice
} from '@app/ps/project-settings/components/bulk-price/bulk-price-step/bulk-price-step.component';
import { OccupationModel } from '@app/ps/models/occupation.model';
import { ExpertModel } from '@app/ps/models/expert.model';
import { Restangular } from 'ngx-restangular';
import {BrandService} from "@app/common/services/brand.service";

@Component({
  selector: 'bulk-price-init',
  templateUrl: './bulk-price-init.component.html',
})
export class BulkPriceInitComponent extends BulkPriceStepComponent implements OnInit {

  loading = false;
  rentalPrice: any;
  purchasePrice: PurchasePrice;
  occupations: OccupationModel[];
  occupationType;
  occupationTypeOptions = [
    // CR-4576 Funkce vypnuta
    //{ id: 'u', value: 'Dočasné zábory do 1 roku'},
    //{ id: 'o', value: 'Dočasné zábory nad 1 rok'},
    { id: 'p', value: 'Trvalé zábory'}
  ];
  public areas;
  public assessment;
  public useAssessment = false;
  titleGroups = [];

  constructor(
    private restangular: Restangular,
    private brandService: BrandService,
  ) {
    super();
    this.onSubmit = this.onSubmit.bind(this);
    this.loadOccupations = this.loadOccupations.bind(this);
  }

  ngOnInit() {
    this.rentalPrice = this.data.rentalPrice || {
      rentalPriceType: 'F',
      rentalPriceUnit: 'A',
      rentalLength: 12,
    };
    this.purchasePrice = this.data.purchasePrice || {
      priceType: 'O',
      priceUnit: 'M',
    };

    this.occupations = this.data.occupations;
    this.occupationType = this.data.occupationType;
    if (!this.brandService.isVisible('mpv')) {
      Promise.all([
        this.loadAreas(),
        this.loadAssessments()
      ]).then(() => {
        if (this.assessment) {
          this.assessment.price = {};
          this.assessment.prices.forEach(p => {
            this.assessment.price[p.areaId] = p.price;
          });
          if (this.areas.some(a => !this.assessment.price[a.id])) {
            this.assessment = null;
          }
        }
      });
      this.useAssessment = true;
    }
  }

  isValid(): boolean {
    let priceValid;

    if (this.occupationType === 'p') {
      priceValid = this.purchasePrice.priceType
        && this.purchasePrice.otherSource
        && this.purchasePrice.priceUnit
        && this.purchasePrice.price !== undefined && this.purchasePrice.price !== '';
    } else {
      priceValid = this.rentalPrice.rentalPriceType
        && this.rentalPrice.rentalLength
        && ((this.occupationType === 'u' && this.rentalPrice.rentalLength <= 12) || (this.occupationType === 'o' && this.rentalPrice.rentalLength > 12))
        && (
          (this.rentalPrice.rentalPriceType === 'F' && ((this.rentalPrice.priceAssessmentYear && this.rentalPrice.priceAssessmentLandPrice) || (this.useAssessment && this.assessment)))
          || (this.rentalPrice.rentalPriceType === 'E' && this.rentalPrice.rentalExpertOpinionNumber && this.rentalPrice.rentalExpertOpinionDate && this.rentalPrice.rentalExpert && this.rentalPrice.priceAssessmentLandPrice)
          || (this.rentalPrice.rentalPriceType === 'O' && this.rentalPrice.rentalOtherPriceSource && ((this.rentalPrice.rentalPriceUnit === 'T' && this.rentalPrice.totalRentPrice) || (this.rentalPrice.rentalPriceUnit === 'A' && this.rentalPrice.priceAssessmentLandPrice)))
        );
    }

    return !!(this.occupations && this.occupations.length && priceValid);
  }

  onSubmit() {
    this.data.rentalPrice = this.rentalPrice;
    this.data.purchasePrice = this.purchasePrice;
    this.data.occupations = this.occupations;
    this.data.occupationType = this.occupationType;
    this.data.useAssessment = this.useAssessment;
    this.data.assessment = this.assessment;
    this.data.areas = this.areas;
    this.data.titleGroups = this.titleGroups;
    this.submitCallback.emit();
  }

  onChangeExpert(expert: ExpertModel) {
    this.rentalPrice.rentalExpert = expert;
  }

  onTypeChange(type: 'o' | 'u' | 'p') {
    if (this.loading) {
      return;
    }
    this.occupationType = type;
    this.loadOccupations();
  }

  private async loadAreas() {
    this.areas = await this.restangular
      .all('areas')
      .customPOST({ filter: { sortOrder: [{sortBy: 'name', direction: 'asc'}], limit: null, filters: {}}})
      .toPromise();
  }

  public async loadAssessments() {
    await this.restangular
      .all('price-assessments').all('list')
      .customPOST()
      .toPromise()
      .then(l => {
        if (l.length) {
          this.assessment = l[l.length - 1];
        }
      });
  }

  private loadOccupations(): Promise<any> {
    this.loading = true;
    const occupationFilter: any = {filter: {filters: {
      validity: ['valid'],
      loadCollections: ['rentalExpert'],
      caseBlockingPriceExists: [false],
      occupationTypeId: [],
    }}};

    if (this.occupationType === 'p') {
      occupationFilter.filter.filters.opinionExists = [false];
    }

    let occupationTypes;

    switch (this.occupationType) {
      case 'u':
        occupationTypes = [ 5, 9, 22, 221, 31 ];
        break;
      case 'o':
        occupationTypes = [ 6, 10, 21, 211 ];
        break;
      case 'p':
        occupationTypes = [ 1, 2, 3, 4, 7, 8, 11, 111, 112, 113, 12, 121, 122, 41, 42 ];
        break;
    }

    const occupationTypeFilter = {filter: {filters: {
      validity: ['valid'],
      // underOneYear, overOneYear, permanent
      number: occupationTypes
    }}};

    return this.restangular.all('occupation-types')
      .customPOST(occupationTypeFilter)
      .toPromise()
      .then(ot => {
        ot = ot.plain();

        if (ot.length === 0) {
          this.loading = false;
          this.occupations = [];
          return Promise.resolve();
        }

        occupationFilter.filter.filters.occupationTypeId = ot.map(i => i.id);

        return this.restangular
          .all('occupations')
          .customPOST(occupationFilter)
          .toPromise()
          .then(data => {
            this.loading = false;
            this.occupations = data.plain();
            this.mapTitleGroups();
          });
      });
    }

    private mapTitleGroups() {
      if (this.occupationType !== 'p') {
        return;
      }

      this.titleGroups = [];

      this.occupations.forEach(o => {
        const exists = this.titleGroups.find(op => op.title.id === o.parcel.title.id);

        if (exists) {
          exists.parcels.push(o.parcel);
        } else {
          this.titleGroups.push({
            title: o.parcel.title,
            parcels: [o.parcel]
          });
        }
      });
    }
}
